$(function () {

  const
    $window = $(window),
    $nav = $(".js-fixedCollectionsNav"),
    $cover = $(".p-cover"),
    FIXED_CLASS = "is-fixed",
    pcQuery = window.matchMedia("(min-width: 900px)");

  if (!$nav.length || !$cover.length) {
    return;
  }

  // navの「本来の(固定されていない)ドキュメント上の位置」。
  // これを基準にすることで、実際にスクロールでヘッダー下に到達した瞬間にだけ
  // 固定に切り替わり、sticky同様の継ぎ目のない見た目になる。
  let navTop;

  const getHeaderOffset = () => {
    const style = getComputedStyle(document.documentElement);
    return parseFloat(style.getPropertyValue("--top-message-height")) + parseFloat(style.getPropertyValue("--header-height"));
  };

  const updateRange = () => {
    const wasFixed = $nav.hasClass(FIXED_CLASS);
    if (wasFixed) {
      $nav.removeClass(FIXED_CLASS);
    }
    navTop = $nav.offset().top;
    if (wasFixed) {
      $nav.addClass(FIXED_CLASS);
    }
  };

  const update = () => {
    // PC(tab-up以上)では対象外
    if (pcQuery.matches) {
      $nav.removeClass(FIXED_CLASS);
      return;
    }

    const scrollEdge = $window.scrollTop() + getHeaderOffset();
    $nav.toggleClass(FIXED_CLASS, scrollEdge >= navTop);
  };

  updateRange();
  update();

  $window.on("scroll", update);

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateRange();
      update();
    }, 100);
  });

});
